import React, { Component } from 'react'
import { PropTypes } from 'prop-types'
import { updateComponent } from '../../state/actions/componentsActions'
import { connect } from 'react-redux'
import { camelize, getValidationsResult, cleanupString } from '../../utils'
import { css, withStyles } from '../../styles/withStyles'
import Link from '../link'
import Styles from './styles'
import LabelWithLink from '../labelWithLink'

class Checkbox extends Component {
  constructor(props) {
    super(props)
  }

  componentDidMount() {
    const { component, dispatch } = this.props
    let value = 'selected'
    if (
      component.value === 'selected' ||
      component.status.indexOf('selected') > -1
    ) {
      this.input.checked = true
      value = 'selected'
    } else {
      this.input.checked = false
      value = ''
    }
    dispatch(
      updateComponent(
        component.id,
        { value, status: component.status.filter(s => s !== 'selected') },
        { bypassValidation: component.status.indexOf('error') < 0 }
      )
    )
    if (component.id === 'SZ0023-SS0048_DM0089_RI0381' && this.input.checked) {
      var isSelected = this.input.checked
      var csInfoArr = [
        'SZ0023-SS0048_DM0089_RI0121',
        //'SZ0023-SS0048_DM0089_RI0122', //Remove component RI0122 begin - end
        'SZ0023-SS0048_DM0089_RI1058', 
        'SZ0023-SS0048_DM0089_RI1059',
        'SZ0023-SS0048_DM0089_RI1060',
        'SZ0023-SS0048_DM0089_RI1061',
        'SZ0023-SS0048_DM0089_RI1056',
        'SZ0023-SS0048_DM0089_RI0126'
      ]
      var csInfoArrBody = {
        //validations : {isRequired: true}, //{isRequired: !isSelected},
        value: '',
        isDisabled: isSelected
      }
      
        csInfoArr.forEach(cid => {
          dispatch(
            updateComponent(
              cid,
              csInfoArrBody,
              { bypassValidation: true }
            )
          )
        })
      }  
  }

  componentWillReceiveProps(nextProps) {
    const { component, dispatch } = this.props

    if (
      nextProps.component &&
      nextProps.component.status.indexOf('selected') > -1 &&
      nextProps.component.value === '' &&
      component.value === 'selected'
    ) {
      this.input.checked = true
      dispatch(updateComponent(component.id, { value: 'selected' }))
    }
  }

  onChange() {
    const { component, dispatch } = this.props

    if (!this.input.disabled) {
      if (component.status.indexOf('checkonly') > -1) {
        if (component.value !== 'selected') {
          dispatch(
            updateComponent(component.id, {
              value: 'selected'
            })
          )
          if (!!component.action)
          {
          dispatch(updateComponent(component.id, component.action))
          }
        }
      } else {
        dispatch(
          updateComponent(component.id, {
            value: this.input.checked ? 'selected' : ''
          })
        )
      }
    }
    
  
  /*@Hack for Info Legali Step*/
  if (component.id === 'SZ0023-SS0048_DM0089_RI0381') {
    var isSelected = this.input.checked
    var csInfoArr = [
      'SZ0023-SS0048_DM0089_RI0121',
      //'SZ0023-SS0048_DM0089_RI0122', //Remove component RI0122 begin - end
      'SZ0023-SS0048_DM0089_RI1058', 
      'SZ0023-SS0048_DM0089_RI1059',
      'SZ0023-SS0048_DM0089_RI1060',
      'SZ0023-SS0048_DM0089_RI1061',
      'SZ0023-SS0048_DM0089_RI1056',
      'SZ0023-SS0048_DM0089_RI0126'
    ]
    var csInfoArrBody = {
      //validations : {isRequired: true}, //{isRequired: !isSelected},
      value: '',
      isDisabled: isSelected
    }
    
      csInfoArr.forEach(cid => {
        dispatch(
          updateComponent(
            cid,
            csInfoArrBody,
            { bypassValidation: true }
          )
        )
      })
    }  
  }
  getProperErrorMessage() {
    const { component } = this.props

    if (!!component.validations.overrides) {
      const validationResult = getValidationsResult({
        component,
        type: 'overrides'
      })
      if (!validationResult.result) {
        return validationResult.errorMessage
      }
    }
    return component.errorMessage && component.errorMessage[0]
  }

  renderLabel() {
    const { component } = this.props

    if (component.description && component.description.split('\n').length > 1) {
      const description = component.description.split('\n')
      return description.map((s, index) => (
        <span key={index}>
          {s}
          <br />
        </span>
      ))
    } else return component.description
  }

  renderLabelWithLink() {
    const { component } = this.props
    const chunks = component.combineComponent.value.split(
      /\s(?=\s§\w*§)|(§\w*§)/g
    )
    let conditionalProps
    if (
      component.combineComponent.link &&
      component.combineComponent.link.method !== 'POST'
    ) {
      conditionalProps = {
        href: component.combineComponent.link.url,
        target: component.combineComponent.link.target
      }
    }
    return (
      <span>
        {chunks.map((chunk, index) => {
          if (component.combineComponent.link) {
            return chunk === component.combineComponent.link.placeholder ? (
              <Link key={index} {...conditionalProps}>
                {component.combineComponent.link.text}
              </Link>
            ) : (
              chunk
            )
          }
        })}
      </span>
    )
  }
  render() {
    const { widget, component } = this.props
    return (
      <div
        {...css(
          this.props.styles.component,
          this.props.styles.checkbox,
          this.props.styles['component--block'],
          this.props.styles[`component--pull-${component.pullTo}`],
          /* ['S8-S8S2D2F3', 'S8-S8S2D1F4'].includes(component.id) && */
          this.props.styles.checkboxContainer
        )}
      >
        <input
          ref={input => {
            this.input = input
          }}
          type="checkbox"
          id={component.id}
          {...css(this.props.styles.input)}
          checked={component.value === 'selected'}
          onChange={() => this.onChange()}
          name={component.id}
          disabled={
            !!component.isDisabled ||
            component.status.indexOf('readonly') > -1 ||
            widget.status.indexOf('readonly') > -1
          }
        />
        {!!component.description && component.description.indexOf("§link§")===-1 && (
          <label
            htmlFor={component.id}
            {...css(
              this.props.styles.label,
              component.status.indexOf('error') > -1 &&
                this.props.styles['label--invalid']
            )}
          >
            {this.renderLabel()}
          </label>
        )}
         {!!component.description && component.description.indexOf("§link§")>-1 && (
          <label
            htmlFor={component.id}
            {...css(
              this.props.styles.label,
              component.status.indexOf('error') > -1 &&
                this.props.styles['label--invalid']
            )}
          >
             <LabelWithLink key={component.name} widget={widget} component={component}/>
          </label>
        )}
        <p>{component.id==='S8-S8S2D1F4'?'Servizio sottoposto a valutazione del gruppo Sella':''}</p>
        {component.descriptionWithLink &&
          !!component.combineComponent.value && (
            <label htmlFor={component.id}>{this.renderLabelWithLink()}</label>
          )}
        <small {...css(this.props.styles['error-msg'])}>
          {camelize(this.getProperErrorMessage(), true, true)}
        </small>
      </div>
    )
  }
}

Checkbox.propTypes = {
  widget: PropTypes.object.isRequired,
  component: PropTypes.object.isRequired,
  styles: PropTypes.object.isRequired
}

const mapStateToProps = (state, ownProps) => {
  const { components } = state
  return { component: components[ownProps.component.id] }
}

export default connect(mapStateToProps)(withStyles(Styles)(Checkbox))



// WEBPACK FOOTER //
// ./components/checkbox/index.js